import { createContext, useContext } from 'react';

import { Environment } from '../Environment';

const DependenciesContext = createContext<Environment>({} as Environment);

export const DependenciesProvider = DependenciesContext.Provider;

export const useDependencies = (): Environment => useContext(DependenciesContext);
